<template>
  <div class="page-container mt-12">
    <MaintainanceMode />
    <ReadOnlyMode class="mt-12" />
  </div>
</template>
<script>
import MaintainanceMode from '@/components/SiteSettings/SiteSettingsMaintainanceMode';
import ReadOnlyMode from '@/components/SiteSettings/SiteSettingsReadOnlyMode';
import {
  mapMutations, mapActions,
} from 'vuex';
export default {
  name: 'SiteSettings',
  components: {
    MaintainanceMode,
    ReadOnlyMode,
  },
  data: () => ({
  }),
  async created() {
    this.spinner(true);
    await this.getListFeatureFlags({
      forceGetting: true,
    });
    this.spinner(false);
  },
  methods: {
    ...mapMutations(['spinner']),
    ...mapActions('SiteConfiguration', ['getListFeatureFlags']),
  },
};
</script>
<style scoped lang="scss">
</style>
